module.exports = __webpack_public_path__ + "img/vk.c6dbcf6c.svg";